import { gql } from "@apollo/client";

export const GET_PROGRAMAS_PERMITIDOS_BY_USER = gql`
query programasPermitidosByUsuario
{
    programasPermitidosByUsuario
    {
        idTipoModulo
        abreviacion
    }
}
`;

export const adaptProgramasPermitidosArray = (
programasPermitidosByUsuario) =>
structuredClone(programasPermitidosByUsuario)?.
map((prog) => ({
  id: prog.idTipoModulo,
  displayName: prog.abreviacion
})

);